import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class DialogService{
    isData: string = '';
    tableData:any;
    imgUrl:string;
    tableIndex:any;
    tableFormate:any;
    confirmMsg:string;
    mode:number;
    id:number;
    studyId:string;

}